import { useState, useCallback } from "react";
import { useGetWithdraws } from "../../lib/queries/queriesAndMutations";
import Loader from "../../shared/Loader";
import WithDrawCard from "../../shared/WithDrawCard";
import ExcelPopupBtn from "./PopupBtns/ExcelPopupBtn";
import FilterDetailBar from "./PopupBtns/FilterDetailBar";
import AdvanceSearchBtn from "./PopupBtns/AdvanceSearchBtn";
import Pagination from "../../shared/Pagination";
import { withdrawFieldLabels, withdrawsFields } from "../../lib/constants";
import { useDebounce } from "../../hooks/useDebounce";
import InformationTooltip from "../../ui/InformationTooltip";

const WithdrawsList = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState({ user_id: "" });
  const debouncedQueryParams = useDebounce(searchTerm, 1024);

  const { data, isPending, isRefetching } = useGetWithdraws({
    debouncedQueryParams,
    currentPage,
  });

  const handlePageChange = useCallback(setCurrentPage, []);

  if (isPending || isRefetching) {
    return (
      <div className="w-full h-full flex justify-center items-center min-h-[400px]">
        <Loader />
      </div>
    );
  }

  const hasResults = data?.count > 0;

  return (
    <>
      <div className="figure-wrapper space-y-2">
        <div className="flex w-full gap-[10px] ">
          <InformationTooltip />
          <ExcelPopupBtn
            searchTermRef={searchTerm}
            fields={withdrawsFields}
            url="withdraws"
          />
          <AdvanceSearchBtn setSearchTerm={setSearchTerm} />
        </div>
        <FilterDetailBar
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          labelFields={withdrawFieldLabels}
        />
      </div>
      <div className="figure-wrapper">
        {/* Results */}
        {hasResults ? (
          <div className="space-y-4 w-full">
            <div className="flex flex-col gap-2 w-full">
              {data?.results.map((item, index) => (
                <WithDrawCard key={item.id} item={item} index={index} />
              ))}
            </div>
            <div className="w-full bg-neutral-10 rounded-v-lg mt-2">
              <Pagination
                onPageChange={handlePageChange}
                totalCount={data?.count || 0}
                currentPage={currentPage}
                pageSize={20}
                siblingCount={1}
              />
            </div>
          </div>
        ) : (
          <EmptyState />
        )}
      </div>
    </>
  );
};

/** Extract Empty State UI for clarity */
const EmptyState = () => (
  <div className=" flex flex-col items-center p-6 rounded-md">
    <img
      src="/images/businessbriefcase.svg"
      alt="No Incomes Found"
      className="max-w-[40px] max-h-[40px] invert rounded-md p-2"
    />
    <p>پرداختی یافت نشد!</p>
  </div>
);

export default WithdrawsList;
